import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

const Footer = () => {
  return (
    <footer className='footer'>
      <div className='footer-content'>

        <div className='footer-section footer-brand'>
          <h3>Tagers Shoppe</h3>
          <p>Discover curios you didn't know you seek. We provide products and experiences that are out of the ordinary.</p>
        </div>

        <div className='footer-section footer-links'>
          <h4>Company</h4>
          <Link to='/'>Home</Link>
          <Link to='/AboutUs'>About Us</Link>
          <Link to='/ContactUs'>Contact Us</Link>
          <Link to='/PrivacyPolicy'>Privacy Policy</Link>
          <Link to='/ReturnsPolicy'>Returns Policy</Link>
          <Link to='/TermsOfService'>Terms of Service</Link>
        </div>

        <div className='footer-section footer-links'>
          <h4>Categories</h4>
          <Link to='/BoardGames'>Board Games</Link>
          <span className='footer-sub-heading'>TCG</span>
          <Link to='/Tcg?franchise=mtg' className='footer-sub-link'>Magic: The Gathering</Link>
          <Link to='/Tcg?franchise=onepiece' className='footer-sub-link'>One Piece</Link>
          <Link to='/Tcg?franchise=riftbound' className='footer-sub-link'>Riftbound</Link>
          <span className='footer-sub-heading'>TCG Accessories</span>
          <Link to='/TcgAccessories?brand=dragonShield' className='footer-sub-link'>Dragon Shield</Link>
          <Link to='/TcgAccessories?brand=luckDragon' className='footer-sub-link'>Luck Dragon</Link>
          <Link to='/TcgAccessories?brand=sleeveKings' className='footer-sub-link'>Sleeve Kings</Link>
          <Link to='/TcgAccessories?brand=armyPainter' className='footer-sub-link'>Army Painter</Link>
          <Link to='/TcgAccessories?brand=gradedGuard' className='footer-sub-link'>Graded Guard</Link>
          <Link to='/TcgAccessories?brand=dice' className='footer-sub-link'>Dice</Link>
        </div>        

        <div className='footer-section footer-contact'>
          <h4>Contact</h4>
          <p>Email: info@tagershoppe.com</p>
        </div>

      </div>

      <div className='footer-bottom'>
        <hr />
        <p>&copy; {new Date().getFullYear()} Tagers Shoppe. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default Footer
